/* @ngInject */
const resource = (
  $resource,
  paths
) => {
  const path = paths.handlers.autocomplete

  return $resource(
    path, {}, {
      'post': {
        method: 'POST',
      },
    }
  )
}

export default resource



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/autocomplete/services/resource.service.js